export default {
  PUSH_WS: 'push.api.drift.com'
};